import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ChevronLeftIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const ChevronLeftIcon: React.FC<ChevronLeftIconProps> = ({ strokeWidth = 3, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-chevron-left">
    <path
      d="M30 12 L18 25 L30 38"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinejoin="miter"
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default ChevronLeftIcon;
